export default "__VITE_ASSET__CqAP487z__"